import { InteractifyPlayer } from '@interactify-live/player-react';
import { useInView } from 'react-intersection-observer';
import { useEffect, useMemo, useRef } from 'react';
import { GetShortVideoListViewModel } from '@/types/cml-api';
import { IconEye } from '@/features/icons';
import { cn } from '@/utils/cn';
import formatLargeNumber from '@/utils/string-helpers/format-large-number';
interface Props {
  item: GetShortVideoListViewModel;
  isVideo: boolean;
  clickHandler: () => void;
}
const SingleShort = ({
  item,
  isVideo,
  clickHandler
}: Props) => {
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '50px'
  });
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (!inView || !isVideo || !videoRef.current || !item.video || videoRef.current.src) return;
    videoRef.current.src = item.video;
    videoRef.current.load();
  }, [inView, isVideo, item.video]);
  useEffect(() => {
    const videoElement = videoRef.current;
    return () => {
      if (!videoElement || !isVideo) return;
      videoElement.src = '';
    };
  }, [isVideo]);
  const style = useMemo(() => isVideo ? undefined : {
    backgroundImage: `url(${item.cover || ''})`
  }, [isVideo, item.cover]);
  return <div ref={ref} role='button' onClick={clickHandler} key={item.slug} className={cn('relative aspect-square w-full cursor-pointer bg-gray-100 bg-cover bg-center', {
    'row-span-2 aspect-auto h-full': isVideo
  })} style={style} data-sentry-component="SingleShort" data-sentry-source-file="single-short.tsx">
            {!!item.viewCount && <div className='absolute bottom-1 left-1 z-10 flex items-center gap-0.5 text-white lg:bottom-1.5 lg:left-2'>
                    <span className='text-caption-10 font-light lg:text-body-14 lg:font-medium'>
                        {formatLargeNumber(item.viewCount)}
                    </span>
                    <IconEye className='h-3 w-3 lg:h-4 lg:w-4' />
                </div>}

            {isVideo && <InteractifyPlayer media={{
      thumbnail: item.cover || '',
      url: item.streamUrl || '',
      id: item.slug || '',
      type: 'video'
    }} interactions={[]} className='h-full w-full [&_video]:!object-cover [&_video]:object-center' autoPlay muted loop />}
        </div>;
};
export default SingleShort;